import React, { HTMLAttributes } from "react";
import cx from "classnames";
import Dialog from "component/atoms/ModalDialog/index";
import ReactTable from "react-table";
import "./HUGuideTable.styl";

const dialogStyles = {
  content: {
    // top: "50%",
    // left: "50%",
    // right: "auto",
    // bottom: "auto",
    // marginRight: "-50%",
    transform: "translate(-50%, -50%)",

    /// 아래 스타일은 stylus로 커스텀 되게 수정하자
    backgroundcolor: "#3c3c3c"
  }
};

/**
 * @todo CSS 정리하기
 *
 * @class MessageBox
 * @extends {React.PureComponent<IMessageBoxProps, IMessageBoxState>}
 */
class HUGuideTable extends React.Component {
  /// 표 컬럼 정의
  columns = [
    {
      Header: "Color",
      accessor: "color", // String-based value accessors!
      width: 70,
      Cell: props => (
        <div
          className="color-cell text-center"
          style={{ backgroundColor: props.value }}
        ></div>
      )
    },
    {
      Header: "Name",
      accessor: "name",
      width: 75,
      Cell: props => <div className="subject-cell">{props.value}</div>
    },
    {
      Header: "Description",
      accessor: "description",
      width: 260
    },
    {
      Header: "HU Value",
      accessor: "HU-Value",
      width: 120
    }
  ];

  dialogPrefix = "HU-guide-table";

  static defaultProps = {
    onClose: null,
    open: false
    //open: true
  };
  constructor(props) {
    super(props);
    this.state = {
      open: props.open
    };
  }
  componentWillReceiveProps = nextProps => {
    this.state.open = nextProps.open;
  };
  shouldComponentUpdate(nextProps, nextState) {
    const vitalPropsChange = this.props.open !== nextProps.open;
    const vitalStateChange = this.state.open !== nextState.open;
    return vitalPropsChange || vitalStateChange;
  }
  closeModal = () => {
    this.setState({ open: false });
    const { onClose } = this.props;

    if (onClose !== null && onClose !== undefined) {
      onClose();
    }
  };

  /**
   * @method render
   * @description 컴포넌트 UI 렌더링
   * @returns
   * @memberof StudyViewTable
   */
  render() {
    const contentClassName = `${this.dialogPrefix}-content`;
    const backgroundClassName = `${this.dialogPrefix}-background`;

    /// 1. 입력된 dataset을 테이블에 입력할 수 있는 형태로 변환한다.
    const { dataset } = this.props;

    const tableContent = dataset.map(row => {
      return {
        color: row["color"],
        name: row["name"],
        description: row["description"],
        "HU-Value": row["HU-Value"]
      };
    });

    const { open } = this.state;
    if (open === false) {
      return true;
    }
    return (
      <Dialog.ModalPortal
        isOpen={this.state.open}
        onRequestClose={this.closeModal}
        className={cx(contentClassName, "noselect", "nodrag")}
        backgroundClassName={backgroundClassName}
        style={dialogStyles}
      >
        <Dialog.DialogLayout.DialogBody
          inlist=""
          dialogPrefix={this.dialogPrefix}
          className="text-center"
        >
          <div className="MuscleHUMeasureRangeGuideTable">
            <ReactTable
              data={tableContent}
              columns={this.columns}
              showPagination={false}
              minRows={5}
              // TbodyComponent={this.customScrollbar}
              noDataText=""
            />
          </div>
        </Dialog.DialogLayout.DialogBody>
      </Dialog.ModalPortal>
    );
  }
}

export default HUGuideTable;
